import axiosConfig from '../../config/axios'
import {StandardResult} from '../../app/core/_core'
import {DataTableRequest} from '../../app/components/Ops/core/_dt'
import {dataTablesResponse} from 'openapi'

export const getPagination = (data: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    // var isTable = data.isTable
    let url = data.url
    let dtRequest = data.payload as DataTableRequest
    dispatch({
      type: 'SET_LOADING',
      key: data.key,
      loading: true,
    })
    axiosConfig
      .post(url, dtRequest)
      .then((res) => {
        var dtResponse = res.data as dataTablesResponse

        dispatch({
          type: 'SET_LOADING',
          key: data.key,
          loading: false,
        })
        dispatch({
          type: 'SET_DATATABLES_RESPONSE',
          key: data.key,
          data: dtResponse,
        })

        resolve(true)
      })
      .catch(() => {
        dispatch({
          type: 'SET_LOADING',
          key: data.key,
          loading: false,
        })
        reject(false)
      })
  })
}

export const deleteByIds = (data: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    let url = data.url
    let payload = data.payload

    dispatch({
      type: 'SET_LOADING',
      key: data.key,
      loading: true,
    })
    axiosConfig
      .post<StandardResult>(url, payload)
      .then((res) => {
        var r = res.data
        if (r.success) {
        } else {
        }
        dispatch({
          type: 'SET_LOADING',
          key: data.key,
          loading: false,
        })
        resolve(r)
      })
      .catch(() => {
        dispatch({
          type: 'SET_LOADING',
          key: data.key,
          loading: false,
        })
        reject(false)
      })
    // resolve(true);
  })
}
